import { FormatHelpers } from "../helpers/format-helpers";
import { IChartContainer } from "../models/base/chart-container.interface";
import { ChartStyleColorModel } from "../models/chart-style/chart-style-color.model";
import { PreviewModeLabelPosition } from "../models/enum/preview-mode-label-position.enum";
import { IComponent } from "./component.interface";
const color = require('../library/darken-color.js');

enum SmallSize {
    None = 0,
    Small = 1,
    Small2x = 2
}

export class MarketingWebChartSummaryStatusLineComponent implements IComponent {
    public id = '';

    private element: HTMLElement;
    private symbol: HTMLElement | null;
    private currentClose: HTMLElement | null;
    private currentAmount: HTMLElement | null;
    private currentPercent: HTMLElement | null;

    private lastPrice = 0;
    private changeFromClosePercentage = 0;
    private changesFromClose = 0;
    private splitMode = false;
    private base: IChartContainer;

    constructor(el: HTMLElement, base: IChartContainer) {
        this.element = el;
        this.base = base;

        this.symbol = this.element.findFirst('.symbol');
        this.currentClose = this.element.findFirst('.current-close');
        this.currentAmount = this.element.findFirst('.current-amount');
        this.currentPercent = this.element.findFirst('.current-percent');
    }

    public isShow(): boolean {
        return !this.element.containClass('hidden');
    }

    public show() {
        this.element.removeClass('hidden');
    }

    public hide() {
        this.element.addClass('hidden');
    }

    private scaleElementPreviewModeTimer: any;
    public scaleElementPreviewMode(percentage: number, labelPosition: PreviewModeLabelPosition, shouldShowSplitMode: boolean, isResize: boolean) {
        if (percentage <= 0) {
            return;
        }

        this.element.classList.remove('top');
        this.base.tiChartSeries.element.classList.remove('transparent-mode');

        const parentElement = this.base.element?.parentElement;
        const parentParentElement = this.base.element?.parentElement?.parentElement;

        this.element.style.height = '';
        this.element.style.padding = '';

        if (shouldShowSplitMode) {
            this.element.style.padding = '0px';
            this.element.style.left = ``;

            this.base.tiChartSeries.element.style.height = '';
            this.base.tiChartSeries.element.style.overflow = '';

            if (parentElement) {
                parentElement.style.overflow = '';
            }

            if (parentParentElement) {
                parentParentElement.style.height = ``;
            }

            this.base.tiChartSeries?.highStockChart?.update({
                chart: {
                    height: null
                }
            }, true);

            this.base.tiChartSeries?.highStockChart?.reflow();
        }

        this.setFontSizes(percentage, shouldShowSplitMode, SmallSize.None);

        const splitModeRender = (smallMode: boolean, width: number, widthLeft: number) => {
            const height = this.element.clientHeight;
            this.base.tiChartSeries.element.style.height = height + 'px';
            this.base.tiChartSeries.element.style.overflow = 'visible';
            
            if (parentElement) {
                parentElement.style.overflow = 'visible';
            }

            if (parentParentElement) {
                parentParentElement.style.height = height + 'px';
            }

            this.base.tiChartSeries.chartElement.style.width = `calc(100% - ${width}px)`;
            this.base.tiChartSeries.chartElement.style.left = `${widthLeft}px`;


            if (smallMode) {
                if (this.currentClose) {
                    this.currentClose.style.setProperty('display', 'none', 'important');
                }
                if (this.currentAmount) {
                    this.currentAmount.style.whiteSpace = 'nowrap';
                    this.currentAmount.style.setProperty('display', 'none', 'important');
                }
                if (this.currentPercent) {
                    this.currentPercent.style.position = `relative`;
                    this.currentPercent.style.transform = `unset`;
                    this.currentPercent.style.whiteSpace = "nowrap";
                    this.currentPercent.style.top = 'unset';
                    this.currentPercent.style.left = '';
                    this.currentPercent.style.order = '1';
                }
            } else {
                if (this.currentPercent) {
                    this.currentPercent.style.whiteSpace = "nowrap";
                    this.currentPercent.style.transform = `translateY(calc(-50% + ${(this.currentPercent.clientHeight / 2) + (this.currentPercent.clientHeight * 0.1)}px))`;
                    this.currentPercent.style.left = (widthLeft + this.base.tiChartSeries.chartElement.clientWidth + 4) + 'px';
                }
                if (this.currentAmount) {
                    this.currentAmount.style.whiteSpace = "nowrap";
                    this.currentAmount.style.transform = `translateY(calc(-50% - ${(this.currentAmount.clientHeight / 2) - (this.currentPercent.clientHeight * 0.15)}px))`;
                    this.currentAmount.style.left = (widthLeft + this.base.tiChartSeries.chartElement.clientWidth + 4) + 'px';
                }
            }

            this.removeNoOpacity();
        };

        clearTimeout(this.scaleElementPreviewModeTimer);
        this.scaleElementPreviewModeTimer = setTimeout(() => {
            if (shouldShowSplitMode) {
                this.splitMode = true;

                this.base.tiChartSeries.element.classList.add('transparent-mode');

                const widthRight = (this.currentPercent?.clientWidth ?? 0) + 20;

                let widthLeft = this.element.clientWidth + 5;
                let width = widthLeft + widthRight;
                const chartApproxWidth = this.base.element.clientWidth - width;

                if (chartApproxWidth <= 55) {

                    if (window.matchMedia('(max-width: 420px)').matches) {
                        this.setFontSizes(60, shouldShowSplitMode, SmallSize.Small2x);
                        widthLeft = 12;
                    } else {
                        this.setFontSizes(75, shouldShowSplitMode, SmallSize.Small);
                        widthLeft = 4;
                    }

                    if (isResize) {
                        widthLeft += 4;
                    }

                    widthLeft += this.element.clientWidth;
                    width = widthLeft;
                    splitModeRender(true, width, widthLeft);
                } else {
                    splitModeRender(false, width, widthLeft);
                }

            } else {
                this.splitMode = false;
                if (labelPosition == PreviewModeLabelPosition.InsideTopLeft) {
                    this.element.style.padding = '';
                    this.element.classList.add('top');

                    this.base.tiChartSeries.chartElement.style.width = '100%';
                    this.base.tiChartSeries.chartElement.style.left = '';
                    this.element.style.left = ``;
                } else if (labelPosition == PreviewModeLabelPosition.OutsideLeft) {
                    this.element.style.padding = '0px';

                    const width = this.element.clientWidth + 5;
                    this.base.tiChartSeries.chartElement.style.width = `calc(100% - ${width}px)`;
                    this.base.tiChartSeries.chartElement.style.left = `${width}px`;
                    this.element.style.left = ``;
                } else if (labelPosition == PreviewModeLabelPosition.OutsideRight) {
                    this.element.style.padding = '0px';

                    const width = this.element.clientWidth + 5;
                    this.base.tiChartSeries.chartElement.style.width = `calc(100% - ${width}px)`;
                    this.base.tiChartSeries.chartElement.style.left = ``;
                    this.element.style.left = `100%`;
                }
            }
        }, 100);
    }

    public setValue(lastPrice: number, changeFromClosePercentage: number, changesFromClose: number) {
        this.lastPrice = lastPrice;
        this.changeFromClosePercentage = changeFromClosePercentage;
        this.changesFromClose = changesFromClose;
    }

    public render(chartStyleColor: ChartStyleColorModel, up: boolean, symbol: string, isDarkTheme: boolean) {
        const close = FormatHelpers.numberToString(this.lastPrice, 2);

        const rawChangeFromClosePercentage = parseFloat(this.changeFromClosePercentage.toFixed(2));
        const rawChangeFromClose = parseFloat(this.changesFromClose.toFixed(2));
        // const changeFromClosePercentage = this.changeFromClosePercentage == 0 ? 0 : Math.abs((this.changesFromClose / this.changeFromClosePercentage) * 100);
        const percentage = FormatHelpers.numberToString(rawChangeFromClosePercentage, 2);
        const amount = FormatHelpers.numberToString(rawChangeFromClose, 2);

        this.symbol?.ifExistThen((el: HTMLElement) => {
            if (isDarkTheme) {
                el.style.color = '#fff';
            } else {
                el.style.color = '#000';
            }
            el.setInnerHtml(symbol);
        });

        const currentCloseText = this.splitMode ? close : '$' + close;
        this.currentClose?.setInnerHtml(currentCloseText);

        this.currentPercent?.findFirst('.txt')?.ifExistThen((el: HTMLElement) => {
            let currentPercentageLabel = percentage + '%';

            if (this.base.isPreview) {
                if (rawChangeFromClosePercentage != 0) {
                    currentPercentageLabel = (up ? '+' : '') + currentPercentageLabel;
                } else {
                    currentPercentageLabel = currentPercentageLabel;
                }
            }

            el.setInnerHtml(currentPercentageLabel);
        });
        this.currentPercent?.findFirst('.icon')?.ifExistThen((el: HTMLElement) => {
            if (!up) {
                el.addClass('down');
            } else {
                el.removeClass('down');
            }
        });
        this.currentPercent?.ifExistThen((el: HTMLElement) => {
            const bgColor = new ChartStyleColorModel(color.HEX2RGB(chartStyleColor.lighten(15)));

            if (this.base.isPreview) {
                el.style.background = 'transparent';
            } else {
                el.style.background = bgColor.toRGBA(0.15);
            }

            el.style.color = chartStyleColor.toRGB();
        });
        this.currentAmount?.ifExistThen((el: HTMLElement) => {
            let currentAmountLabel = amount;
            if (rawChangeFromClose != 0) {
                currentAmountLabel = (up ? '+' : '') + amount;
            }
            
            el.setInnerHtml(currentAmountLabel);
            el.style.color = chartStyleColor.toRGB();
        });
    }

    private setFontSizes(percentage: number, shouldShowSplitMode: boolean, smallSize: SmallSize) {
        const height = this.base.tiChartSeries.element.clientHeight * (percentage / 100);

        this.symbol?.ifExistThen((el: HTMLElement) => {
            let ratio = 0.5;

            if (shouldShowSplitMode) {
                ratio = 0.5;

                if (smallSize == SmallSize.Small) {
                    ratio = 0.6;
                } else if (smallSize == SmallSize.Small2x) {
                    ratio = 0.48;
                }

                el.addClass('no-opacity');
            } else {
                el.removeClass('no-opacity');
            }

            const fontSize = height * ratio;
            el.style.fontSize = `${fontSize}px`;
        });

        this.currentPercent?.ifExistThen((el: HTMLElement) => {
            el.style.position = '';
            el.style.transform = '';
            el.style.top = '';
            el.style.left = '';
            el.style.order = '';
            el.style.fontWeight = '';
            el.style.whiteSpace = '';

            let ratio = 0.25;

            if (shouldShowSplitMode) {
                ratio = 0.35;

                if (smallSize == SmallSize.Small) {
                    ratio = 0.35;
                } else if (smallSize == SmallSize.Small2x) {
                    ratio = 0.43;
                }

                el.addClass('no-opacity');
                el.style.fontWeight = 'bold';
            } else {
                el.removeClass('no-opacity');
            }

            const fontSize = height * ratio;
            el.style.fontSize = `${fontSize}px`;

            const svg = el.querySelector('svg');
            if (svg) {
                svg.style.width = `${fontSize}px`;
                svg.style.height = `${fontSize}px`;
            }
        });

        this.currentAmount?.ifExistThen((el: HTMLElement) => {
            el.style.display = '';
            el.style.position = '';
            el.style.transform = '';
            el.style.top = '';
            el.style.left = '';
            el.style.fontWeight = '';
            el.style.whiteSpace = '';

            if (shouldShowSplitMode) {
                let ratio = 0.35;

                if (smallSize == SmallSize.Small) {
                    ratio = 0.25;
                } else if (smallSize == SmallSize.Small2x) {
                    ratio = 0.25;
                }
                
                el.addClass('no-opacity');

                el.style.fontWeight = 'bold';

                const fontSize = height * ratio;
                el.style.fontSize = `${fontSize}px`;
            } else {
                el.style.fontSize = ``;
                el.removeClass('no-opacity');
            }
        });

        this.currentClose?.ifExistThen((el: HTMLElement) => {
            el.style.display = '';
            el.style.fontWeight = '';

            if (shouldShowSplitMode) {
                const ratio = 0.30;

                el.addClass('no-opacity');

                el.style.fontWeight = 'bold';

                const fontSize = height * ratio;
                el.style.fontSize = `${fontSize}px`;
            } else {
                el.style.fontSize = ``;
                el.removeClass('no-opacity');
            }
        });
    }

    private removeNoOpacity() {
        this.symbol?.removeClass('no-opacity');
        this.currentPercent?.removeClass('no-opacity');
        this.currentAmount?.removeClass('no-opacity');
        this.currentClose?.removeClass('no-opacity');
    }
}